/**
 * @format
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import { Col, Row } from 'antd';
import LogoMain from 'img/synergy-main.png';
import LogoCircle from 'img/Synergy-Logo-Circle.png';
import Logout from 'components/widgets/logoutButton';
import { MenuSection } from '../types/menu.types';
import HelpIcon from 'img/Info.svg';

interface MenuProps {
  sections: MenuSection[];
  isMenuOpen: boolean;
  activeLink: string;
  onNavClick: (linkId: string) => void;
}

/**
 * Presentational Menu component
 * Displays navigation menu with sections and links
 */
const Menu: React.FC<MenuProps> = ({
  sections,
  isMenuOpen,
  activeLink,
  onNavClick,
}) => {
  const leftStyle: React.CSSProperties = {
    width: isMenuOpen ? '212px' : '70px',
    transition: 'width 0.3s',
  };

  const imgStyle: React.CSSProperties = {
    height: isMenuOpen ? '44px' : '40px',
    width: isMenuOpen ? '180px' : '40px',
    alignItems: !isMenuOpen ? 'center' : 'flex-start',
    transition: 'width 0.3s, height 0.3s',
  };

  return (
    <div className='menu-container' style={leftStyle}>
      <div>
        <img
          src={isMenuOpen ? LogoMain : LogoCircle}
          alt='Synergy Logo'
          style={imgStyle}
        />
      </div>

      {sections.map((section) => (
        <Row key={section.category} gutter={[4, 4]}>
          {isMenuOpen ? (
            <div style={{ padding: '8px' }}>
              <span className='title'>{section.title}</span>
            </div>
          ) : (
            <div style={{ padding: '12px 4px' }}>
              <span className='menu-title'>{section.shortTitle}</span>
            </div>
          )}
          <Col xs={24} lg={24}>
            <div className='menu-list'>
              <ul>
                {section.items.map((item) => (
                  <li key={item.id}>
                    <NavLink
                      onClick={() => onNavClick(item.id)}
                      to={item.path}
                      className={`nav-link ${
                        activeLink === item.id ? 'active-link' : ''
                      }`}
                      style={{
                        justifyContent: isMenuOpen ? 'normal' : 'center',
                      }}>
                      <img
                        src={activeLink === item.id ? item.iconFilled : item.icon}
                        alt={`${item.label} Icon`}
                        style={
                          item.id === 'vendors' || item.id === 'customers'
                            ? { width: '20px' }
                            : undefined
                        }
                      />
                      {isMenuOpen && <span>{item.label}</span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      ))}

      <Row gutter={[4, 4]}>
        {isMenuOpen ? (
          <div style={{ padding: '8px' }}>
            <span className='title'>Account</span>
          </div>
        ) : (
          <div style={{ padding: '12px 4px' }}>
            <span className='menu-title'>acc...</span>
          </div>
        )}
        <Col xs={24} lg={24}>
          <div className='menu-list'>
            <ul>
              <li>
                <a
                  href='https://synergyinsuranceaffiliates.zohodesk.com/portal/en/kb/synergy-insurance-affiliates'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='nav-link'
                  style={{
                    justifyContent: isMenuOpen ? 'normal' : 'center',
                  }}>
                  <img src={HelpIcon} alt='Help Icon' />
                  {isMenuOpen && <span>Help Center</span>}
                </a>
              </li>
              <Logout />
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Menu;
